import { render, staticRenderFns } from "./ActionsJournal.vue?vue&type=template&id=49cf19c4&"
import script from "./ActionsJournal.vue?vue&type=script&lang=js&"
export * from "./ActionsJournal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports